import Panel from './HOClevel'

export default Panel
